import { render, staticRenderFns } from "./BaseFlag.vue?vue&type=template&id=c29cba32&"
import script from "./BaseFlag.vue?vue&type=script&lang=js&"
export * from "./BaseFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports